import { render, staticRenderFns } from "./ItemPlannerItem.vue?vue&type=template&id=9fe66522&scoped=true&"
import script from "./ItemPlannerItem.vue?vue&type=script&lang=js&"
export * from "./ItemPlannerItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9fe66522",
  null
  
)


    import installComponents from "!/Users/dhulsman/Projects/rentmagic.website.vue.defietsambassadegent/node_modules/bootstrap-vue-loader/lib/runtime/installComponents.js"
    import {BButton, BCol, BRow} from 'bootstrap-vue'
    installComponents(component, {BButton, BCol, BRow})
    

export default component.exports